import React from "react";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import ChartBarsSkeleton from "./chartBarsSkeleton";
import ChartPieSkeleton from "./chartPieSkeleton";
import ChartLineSkeleton from "./chartLineSkeleton";
import { WidgetSkeleton } from "./index";
import ChartNumberSkeleton from "./chartNumberSkeleton";

type ChartSkeletonSelectorProps = {
  chartType?: WintSuperkollAPIModel.ReportWidgetType | undefined;
  minHeight?: number;
};

const ChartSkeletonSelector: React.FC<ChartSkeletonSelectorProps> = (props) => {
  const { chartType, minHeight } = props;

  switch (chartType) {
    case WintSuperkollAPIModel.ReportWidgetType.Bar:
      return <ChartBarsSkeleton minHeight={minHeight} />;
    case WintSuperkollAPIModel.ReportWidgetType.Line:
      return <ChartLineSkeleton minHeight={minHeight} />;
    case WintSuperkollAPIModel.ReportWidgetType.Pie:
      return <ChartPieSkeleton minHeight={minHeight} />;
    case WintSuperkollAPIModel.ReportWidgetType.Number:
      return <ChartNumberSkeleton minHeight={minHeight} />;
    case WintSuperkollAPIModel.ReportWidgetType.Tree:
      // TODO: Create TreeChartSkeleton
      return <WidgetSkeleton />;
    default:
      // Default fallback for unknown types or while determining type
      return <></>;
  }
};

export default ChartSkeletonSelector;
